import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'bd-resources-list-loading',
  template: `
    <div>
      <div class="flex flex-col md:flex-row gap-0 md:gap-6">
        <div class="flex-1">
          <div>
            <p-skeleton height="20px" width="100%"></p-skeleton>
          </div>
          <div>
            <p-skeleton height="2px" width="100%"></p-skeleton>
          </div>
        </div>

        <div class="basis-full md:basis-1/5">
          <div>
            <p-skeleton height="20px" width="100%"></p-skeleton>
          </div>
          <div>
            <p-skeleton height="2px" width="100%"></p-skeleton>
          </div>
        </div>
      </div>

      @for (repeat of repetition; track repeat) {
        <div class="resources-list-item">
          <div class="flex flex-row gap-6">
            <div class="flex-1">
              <p-skeleton height="20px" width="66%"></p-skeleton>
            </div>
            <div class="basis-full md:basis-1/6">
              <div>
                <p-skeleton height="20px" width="100%"></p-skeleton>
              </div>
              <div>
                <p-skeleton height="2px" width="100%"></p-skeleton>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  `,
  styles: [
    `
      .resources-list-item {
        padding: 12px 24px;
      }
    `,
  ],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SkeletonModule],
})
export class BdResourcesListLoadingComponent {
  public repetition = [1, 2, 3, 4, 5];
}
